import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 7.333h-.713a5.33 5.33 0 0 0-4.62-4.62V2a.667.667 0 1 0-1.334 0v.713a5.33 5.33 0 0 0-4.62 4.62H2a.667.667 0 0 0 0 1.334h.713a5.334 5.334 0 0 0 4.62 4.62V14a.667.667 0 1 0 1.334 0v-.713a5.334 5.334 0 0 0 4.62-4.62H14a.667.667 0 1 0 0-1.334m-2.667 1.334h.607a4 4 0 0 1-3.273 3.273v-.607a.667.667 0 1 0-1.334 0v.607A4 4 0 0 1 4.06 8.667h.607a.667.667 0 1 0 0-1.334H4.06A4 4 0 0 1 7.333 4.06v.607a.667.667 0 1 0 1.334 0V4.06a4 4 0 0 1 3.273 3.273h-.607a.667.667 0 1 0 0 1.334M8 7.333a.667.667 0 1 0 0 1.333.667.667 0 0 0 0-1.333"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })